<template>
  <div style="font-family: Dosis, Helvetica, Arial, sans-serif; font-size: 16px;">
    <el-row>
      <el-col :lg="18" style="text-align: center">
        <el-image v-if="post.photoPrincipale != null"
                  style="height: 350px;max-width: 550px;"
                  :src="post.photoPrincipale.url">
        </el-image>
      </el-col>
      <el-col :lg="6">
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[1] != null"
                      :src="post.photos[1].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[2] != null"
                      :src="post.photos[2].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24">
            <el-image v-if="post.photos[3] != null"
                      :src="post.photos[3].url" fit="cover" style="height: 111px">
            </el-image>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 15px;">
      <div v-if="post.prixDisplay || post.honoraire_charge_acquereur || this.prixDisplay">
        <div class="grid-content bg-purple text-center" id="blockPrix">
          <div v-if="this.prixDisplay">
            <strong>{{ $t("posts.view.saleConditionsPrice") }} : {{this.prixDisplay}}</strong>
          </div>
          <div v-else>
            <strong>{{ $t("posts.view.saleConditionsPrice") }} : {{post.prixDisplay}}</strong><br>
            <div v-if="post.prix_terrain">{{ $t("posts.view.saleConditionsLand") }} : {{post.prix_terrain}}  {{ post.devise_iso_4217 }}</div>
            <div v-if="post.honoraire_charge_acquereur">{{ $t("posts.view.saleConditionsBuyerFee") }} :
              {{post.honoraire_charge_acquereur}}
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row>
      <ul style="padding-left: 50px;">
        <el-col :lg="8">
          <li v-if="post.surface_utile">{{ $labels.surface_utile }} : {{ post.surface_utile }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_habitable">{{ $labels.surface_habitable }} : {{ post.surface_habitable }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.depot_garantie">{{ $labels.depot_garantie }} : {{ post.depot_garantie }} {{ post.devise_iso_4217 }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.honoraires_location">{{ $labels.honoraires_location }} : {{ post.honoraires_location }} {{ post.devise_iso_4217 }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.surface_sejour">{{ $labels.surface_sejour }} : {{ post.surface_sejour }} m²</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.avec_jardin">{{ $labels.avec_jardin }} : {{ displayBoolean(post.avec_jardin) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_garages">{{ $labels.nb_garages }} : {{ post.nb_garages }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_pieces_logement">{{ $labels.nb_pieces_logement }} : {{ post.nb_pieces_logement }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nombre_de_chambres">{{ $labels.nombre_de_chambres }} : {{ post.nombre_de_chambres }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.nb_salles_de_bain">{{ $labels.nb_salles_de_bain }} : {{ post.nb_salles_de_bain }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.balcon">{{ $labels.balcon }} : {{ displayBoolean(post.balcon) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.terrasse">{{ $labels.terrasse }} : {{ displayBoolean(post.terrasse) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.cave">{{ $labels.cave }} : {{ displayBoolean(post.cave) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.date_disponibilite">{{ $labels.date_disponibilite }} : {{ displayBoolean(post.date_disponibilite) }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.belle_vue">{{ $labels.belle_vue }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.vue_sur_mer">{{ $labels.vue_sur_mer }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.est_calme">{{ $labels.est_calme }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.avec_vis_a_vis">{{ $labels.avec_vis_a_vis }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_bus">{{ $labels.proche_bus }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_tram">{{ $labels.proche_tram }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_metro">{{ $labels.proche_metro }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_gare">{{ $labels.proche_gare }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_commerces">{{ $labels.proche_commerces }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.ecoles_a_proximitees">{{ $labels.ecoles_a_proximitees }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.proche_creche">{{ $labels.proche_creche }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.espaces_verts">{{ $labels.espaces_verts }}</li>
        </el-col>
        <el-col :lg="8">
          <li v-if="post.chauffage_energie">{{ $labels.chauffage_energie }} : {{ displayBoolean(post.chauffage_energie) }}</li>
        </el-col>
      </ul>

    </el-row>

    <el-row>

      <el-col :lg="13" style="border: solid;
        border-color: #00b4cc;
        border-width: 1px;
        margin-top: 20px;
        margin-right: 5px;
        overflow: hidden;
        text-align: center">
        <strong>{{ post.titre }}</strong>
        <p style="font-size: 16px;text-align: justify;margin-top: 15px;
        margin: 15px;text-size-adjust: auto;">{{ truncateText(post.texte) }}</p>
        <div>
          <strong>{{$t('posts.offerDescription')}}</strong>
          <p style="font-size: 16px;text-align: justify;margin-top: 15px;
        margin: 15px;margin-bottom: 1px">
            <el-row :gutter="20">
              <ul>
                <li>{{ $t("posts.offerType") }} : {{post.typeOffreLibelle}}</li>
                <li>{{ $t('posts.edit.propertyType') }} : {{post.typeBienLibelle}}</li>
                <li v-if="post.honoraires_payeurs">{{ $t('posts.edit.costsWillBeBorneBy') }} : {{post.honoraires_payeurs}}</li>
              </ul>
            </el-row>
          </p>
        </div>
        <div :style="fontStyleRef">
          <strong>{{ $t('posts.view.referenceAnnonce') }} : {{ post.reference }}</strong>
        </div>
<!--        <div v-if="post.exposition || post.environnement || post.belle_vue || post.standing ||-->
<!--                        post.vue_sur_mer || post.est_calme || post.avec_vis_a_vis || post.proche_bus ||-->
<!--                        post.proche_tram || post.proche_metro || post.proche_gare || post.proche_commerces ||-->
<!--                        post.ecoles_a_proximitees || post.proche_creche || post.espaces_verts">-->
<!--          <strong>{{ $t('posts.environmentTitle')}}</strong>-->
<!--          <p style="font-size: 16px;text-align: justify;margin-top: 15px;-->
<!--        margin: 15px;">-->
<!--            <el-row :gutter="20">-->
<!--              <el-col>-->
<!--                {{ environnementString }}-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </p>-->
<!--        </div>-->
      </el-col>
      <el-col :lg="10" style="margin-top: 20px;">
        <el-row>
          <el-col :lg="24" style="border: solid;
                                  text-align: -webkit-center;
                                  border-color: #00b4cc;
                                  border-width: 1px;
                                  padding-bottom: 20px;
                                  height: 215px;
                                  " v-if="post.dpe_etiquette_conso && post.dpe_etiquette_ges">
            <EtiquetteDPEGESPdfNew :post="post"></EtiquetteDPEGESPdfNew>
          </el-col>
        </el-row>
        <el-row style="margin-top: 4px;">
          <el-col :lg="24"
                  style="border: solid;
                  border-color: #00b4cc;
                  border-width: 1px;padding-top: 10px;">
            <el-row align="middle">
              <el-col :lg="10" align="center">
                <img v-if="sitimmoUser.logoUrl"
                     :src="'data:image/png;base64,' + sitimmoUser.logo" width="100"/>
                <div v-else>&nbsp;</div>
              </el-col>
              <el-col :lg="13">
                <p :style="fontStyleMail">
                    {{sitimmoUser.raisonSociale}}<br>
                  <div v-if="post.contact_a_afficher" :style="fontStyleMail">
                    {{ post.contact_a_afficher }}
                  </div>
                  <div :style="fontStyleMail" v-if="post.adresse_contact_a_afficher && post.code_postal_contact_a_afficher && post.ville_contact_a_afficher">
                    {{post.adresse_contact_a_afficher}} - {{post.code_postal_contact_a_afficher}} {{post.ville_contact_a_afficher}}
                  </div>
                  <div :style="fontStyleMail" v-else>
                    {{sitimmoUser.adresse}} - {{sitimmoUser.codePostal}} {{sitimmoUser.ville}}
                  </div>
                  <div v-if="post.telephone_a_afficher && post.email_a_afficher" :style="fontStyleMail">
                    <strong>Tel. : {{post.telephone_a_afficher}}<br>
                      Mail : {{post.email_a_afficher}}<br></strong>
                  </div>
                  <div v-else :style="fontStyleMail">
                    <strong>Tel. : {{sitimmoUser.telephone}}<br>
                      Mail : {{sitimmoUser.email}}<br></strong>
                  </div>
                </p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
<!--        <el-row style="margin-top: 4px;">-->
<!--          <el-col :lg="24"-->
<!--                  style="border: solid;-->
<!--                  border-color: #00b4cc;-->
<!--                  border-width: 1px;padding:5px;">-->
<!--            <div :style="fontStyleRef">-->
<!--              <strong>{{ $t('posts.view.referenceAnnonce') }} : {{ post.reference }}</strong>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-col>

    </el-row>
  </div>
</template>

<script>
import { deviseSimple } from '@/services/toolbox'
import EtiquetteDPEGESPdfNew from '@/pages/posts/forms/Block/EtiquetteDPEGESPdfNew'

export default {
  name: 'PostPdfImmoAncien',
  components: { EtiquetteDPEGESPdfNew },
  props: ['post', 'sitimmoUser', 'universe'],
  data () {
    return {
      prixDisplay: null,
      stylePrix: 'color:#0ab1bf;font-size: 100px;',
      environnementData: [],
      environnementString: '',
      fontStyleMail: 'font-size: 12px;text-size-adjust: auto;',
      fontStyleRef: 'font-size: 12px;text-size-adjust: auto;text-align:right;padding-right:5px'
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    truncateText (texte) {
      let suffix = ''
      if (texte.length > 600) {
        suffix = suffix + '...'
      }
      return texte.substring(0, 600) + suffix
    },
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return value
    },
    fontSizeEmail () {
      if (this.user.email && this.user.email.length >= 22) {
        this.fontStyleMail = 'font-size: 10px;text-size-adjust: auto;'
      }
    },
    convertDevise (devise) {
      return deviseSimple(devise)
    },
    convertText () {
      const text = this.post.equipments + ' ' + this.post.texte
      return text.substring(0, 1000)
    },
    formatEnvironnement () {
      if (this.post.belle_vue) {
        this.environnementData.push(this.$labels.belle_vue)
      }
      if (this.post.vue_sur_mer) {
        this.environnementData.push(this.$labels.vue_sur_mer)
      }
      if (this.post.est_calme) {
        this.environnementData.push(this.$labels.est_calme)
      }
      if (this.post.avec_vis_a_vis) {
        this.environnementData.push(this.$labels.avec_vis_a_vis)
      }
      if (this.post.proche_bus) {
        this.environnementData.push(this.$labels.proche_bus)
      }
      if (this.post.proche_tram) {
        this.environnementData.push(this.$labels.proche_tram)
      }
      if (this.post.proche_metro) {
        this.environnementData.push(this.$labels.proche_metro)
      }
      if (this.post.proche_gare) {
        this.environnementData.push(this.$labels.proche_gare)
      }
      if (this.post.proche_commerces) {
        this.environnementData.push(this.$labels.proche_commerces)
      }
      if (this.post.ecoles_a_proximitees) {
        this.environnementData.push(this.$labels.ecoles_a_proximitees)
      }
      if (this.post.proche_ecole_primaire) {
        this.environnementData.push(this.$labels.proche_ecole_primaire)
      }
      if (this.post.proche_creche) {
        this.environnementData.push(this.$labels.proche_creche)
      }
      if (this.post.espaces_verts) {
        this.environnementData.push(this.$labels.espaces_verts)
      }

      this.environnementString = this.environnementData.join(', ')
      this.environnementString = this.environnementString.toLowerCase()
      this.environnementString = this.environnementString[0].toUpperCase() + this.environnementString.slice(1)
    }
  },
  beforeMount () {
    if (this.post.financement_mensualites) {
      this.stylePrix = 'color:#0ab1bf;font-size: 72px;'
    }
    this.formatEnvironnement()
  }
}
</script>

<style>

</style>
